const defaultConfig = {
  imageDirectoryPath: '',
  javaScriptDirectoryPath: '',
};

const config = (() => {
  let tempConfig = {};

  // window.HwConfig is declared as inline-script in project/Configuration/TypoScript/Setup/page.typoscript
  if (window.HwConfig) {
    tempConfig = Object.assign({}, defaultConfig, window.HwConfig);
  }

  return tempConfig;
})();

export default config;
